import styled from 'styled-components';
import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { authState } from '../../../atoms/authState';
import AdminHeader from './admin.header';

interface ILayoutProps {
  children: ReactNode;
  menuTitle: string;
}

interface LocationState {
  pathname: string;
}

const AdminLayout = ({ children, menuTitle }: ILayoutProps) => {
  const { pathname } = useLocation() as LocationState;
  const auth = useRecoilValue(authState); // Recoil에서 상태 가져오기

  const isAdmin = auth.userType === 'admin';

  const renderHeader = () => {
    if (pathname === '/admin/login') {
      // /login 또는 / 경로일 때 헤더 숨기기
      return null;
    }

    if (isAdmin) {
      return <AdminHeader />;
    }
  };

  return (
    <Container>
      <Inner>
        {renderHeader()}
        {pathname === '/admin/login' ? null : (
          <MenuTitle>
            <p>{menuTitle}</p>
          </MenuTitle>
        )}
        <Body>{children}</Body>
      </Inner>
    </Container>
  );
};

export default AdminLayout;

// Styles
const Container = styled.div`
  height: 100vh;
  background-color: ${(props) => props.theme.textWhiteColor};
`;

const Inner = styled.div`
  height: 100%;
  display: grid;
  grid-template-rows: auto min-content 1fr; /* 1fr로 Body가 남은 공간을 차지 */
`;

const Body = styled.main`
  align-self: stretch;
  position: relative;
`;

const MenuTitle = styled.section`
  padding: 6.4rem 0 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  p {
    font-size: 3.2rem;
    font-weight: 700;
    color: ${(props) => props.theme.textWhiteColor};
    z-index: 1;
  }
  &::after {
    content: '';
    position: absolute;
    width: 100%;
    height: 18.3rem;
    display: flex;
    top: 0;
    left: 0;
    background-image: url(${require('../../../assets/img/topbanner_member.png')});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 0 0;
  }
`;
